import React from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../auth/AuthProvider";
import { PageHeader } from "../commons/PageHeader";
import { LoginHeader } from "../header/LoginHeader";
import { Spacer } from "../../designSystem";
import { AppShell } from "./AppShell";

interface Props {
  hideLoginHeader?: boolean;
  header?: React.ReactNode;
  showSidebar?: boolean;
  children: React.ReactNode;
  hideBackground?: boolean;
}

const contentStyle: React.CSSProperties = {
  padding: "var(--page-pad)",
  minHeight: "100%",
  boxSizing: "border-box",
};

export const DashboardContainer: React.FC<Props> = ({
  hideLoginHeader,
  header,
  showSidebar,
  children,
  hideBackground,
}) => {
  const { setIsInvestor } = React.useContext(AuthContext);
  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname.replace(/^\/+/g, "").substring(0, 8) === "investor") {
      setIsInvestor(true);
    }
  }, [location.pathname, setIsInvestor]);

  const appHeader =
    header ??
    (!hideLoginHeader ? (
      <LoginHeader className={hideBackground ? "header-fixed" : "show-bg"} showSidebar={showSidebar} />
    ) : undefined);

  return (
    <>
      {showSidebar ? (
        <AppShell appHeader={appHeader}>
          <div style={contentStyle}>
            <PageHeader />
            <div>{children}</div>
            <Spacer height={100} />
          </div>
        </AppShell>
      ) : (
        <>
          {appHeader}
          {children}
        </>
      )}
    </>
  );
};
